import { defineMessages } from 'react-intl';

export default defineMessages({
    phoneValidationError: {
        id: 'usersprofile.views.amp-users-profile.Value entered must be a valid phone numbers',
        defaultMessage: 'Value entered must be a valid phone number'
    }
});
